import React from 'react';
import { useAdmin } from '../contexts/AdminContext';
import AdminLogin from '../components/AdminLogin';
import AdminDashboard from '../components/AdminDashboard';

const AdminPage = () => {
  const { isAdmin, isLoading, user, login, logout } = useAdmin();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <div>
      {isAdmin ? (
        <AdminDashboard onLogout={logout} user={user} />
      ) : (
        <AdminLogin onLogin={login} />
      )}
    </div>
  );
};

export default AdminPage;
